/* eslint no-unused-vars: 'off'  */
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/promise';
import 'core-js/es6/object';
import 'raf/polyfill';
import React from 'react';
import ReactDom from 'react-dom';
import UAParser from 'ua-parser-js';
import App from './App';
import EventHub from './eventHub';
import { bus } from './event/message_events';

/**
 * @des: 肖恩老师的消息-jssdk
 * @params:
 * el - 元素或者选择器
 * pollTime - 定时查询消息时间(default 15s)
 * isSendFile - 是否要发送工程(default false)
 * isVideo - 是否需要语音（default false）
 * isFile - 是否需要文件 (default false)
 * disabledSendAudioGray 禁用发送音频灰度 (default false)
 * handleSendFile - 发送工程文件的回调函数
 */
class XM extends EventHub {
  constructor(options = {}) {
    super();
    const { el } = options;
    this.el = this._isElement(el) ? el : document.querySelector(el);
    this.data = options.data;
    this.methods = this._bindMethods(options.methods);
    this.app = null;
    this.fn = {};
    this.bus = bus;
    this._fnExtends = this._fnExtends.bind(this);
    this._setDataSys();
    this.render();
  }

  // 拓展方法
  _fnExtends(funcName, fn) {
    this.fn[funcName] = fn;
  }

  // 加上版本信息
  _setDataSys() {
    const parser = new UAParser();
    const browser = this._getBrowser(parser);
    const os = parser.getOS();
    this.data.ua = {
      browser: `${browser.name}/${browser.version}`,
      sysVersion: `${os.version}`,
      os: os.name,
    };
  }

  _getBrowser(parser) {
    const ua = navigator.userAgent;
    const xigua = 'xiguaBrowser';
    if (ua.match(xigua)) {
      const name = xigua;
      const flag = ua.split(xigua)[1] || '';
      const version = flag.split(' ')[0];
      return {
        name,
        version: version.split('/')[1],
      };
    }
    return parser.getBrowser();
  }

  _bindMethods(methodsCollection = {}) {
    return Object.assign(methodsCollection, {
      emit: (event, ...params) => {
        this.emit(event, ...params);
      },
    });
  }

  // 判断是否为DOM元素
  _isElement(el) {
    return el && el.nodeType === 1;
  }

  // 全局调用
  // noinspection JSUnusedGlobalSymbols
  updateSendAudioStatus = (status) => {
    this.app.updateSendAudioStatus(status);
  };

  // 渲染组件
  render(callback) {
    this.app = ReactDom.render(
      <App
        data={this.data}
        fnExtends={this._fnExtends}
        methods={this.methods}
      />,
      this.el,
      callback,
    );
  }

  // 改变数据
  // noinspection JSUnusedGlobalSymbols
  changeData(data) {
    this.app.setState((prev) => ({
      data: data ? Object.assign(prev.data, data) : prev.data,
    }));
  }
  
  // 设置回调方法，
  setMethods = (methods) => {
    this.app.setState((prev) => ({
      methods: methods ? Object.assign(prev.methods, methods) : this.methods,
    }));
  }
}

export default XM;
